<se-autocomplete-cell-editor-popup [autocompleteFormControl]="formControl" [items]="items()" [cellReady]="cellReady()">
</se-autocomplete-cell-editor-popup>
